import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { emptyFunction } from '../../core/util/function';
import styled, { withTheme } from 'styled-components';
import { fontFamily, fontSize } from '../../constants/text';

class AccordionExpansionPanel extends Component {
  state = {
    expanded: null,
  };

  handleChange = id => (event, expanded) => {
    this.setState({
      expanded: expanded ? id : false,
    });
  };

  render() {
    const { panels, theme } = this.props;
    const { expanded } = this.state;

    const Root = styled.div`
      width: ${theme.width};
      background-color: ${theme.backgroundColor};
      a {
        text-decoration: ${theme.a.textDecoration};
      }
    `;

    const StyledExpansionPanel = styled(ExpansionPanel)`
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2) !important;
      &::before {
        background-color: ${theme.backgroundColor}!important;
      }
    `;

    const StyledPanelSummary = styled(ExpansionPanelSummary)`
      background-color: ${theme.panelSummary.backgroundColor}!important;
      p {
        color: ${theme.panelSummary.p.color};
        cursor: pointer;
      }
    `;

    const StyledPanelDetails = styled(ExpansionPanelDetails)`
      background-color: ${theme.panelDetails.backgroundColor};
      p {
        color: ${theme.panelDetails.p.color};
        line-height: 24px;
        font-size: 12px;
        color: #dee6eb;
        cursor: pointer;
        font-family: ${fontFamily.book};
        margin: ${theme.panelDetails.p.margin};
        -webkit-font-smoothing: antialiased;
      }
      padding: 0 24px 10px !important;
    `;

    return (
      <Root>
        {panels.map(panel => (
          <StyledExpansionPanel
            key={panel.id}
            expanded={expanded === panel.id}
            onChange={!panel.disableExpansion ? this.handleChange(panel.id) : emptyFunction}
          >
            <StyledPanelSummary expandIcon={panel.expandIcon}>{panel.title}</StyledPanelSummary>
            <StyledPanelDetails>{panel.content}</StyledPanelDetails>
          </StyledExpansionPanel>
        ))}
      </Root>
    );
  }
}

AccordionExpansionPanel.propTypes = {
  theme: PropTypes.object,
  panels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      expandIcon: PropTypes.object,
      onExpandOverride: PropTypes.func,
      title: PropTypes.object,
      content: PropTypes.object,
    })
  ),
};

AccordionExpansionPanel.defaultProps = {
  theme: {
    backgroundColor: 'white',
    width: '100%',
    a: {
      textDecoration: 'underlined',
    },
    panelDetails: {
      backgroundColor: 'white',
      p: {
        color: 'black',
        margin: '12px 0',
      },
    },
    panelSummary: {
      backgroundColor: 'white',
      p: {
        color: 'black',
      },
    },
  },
};

export default withTheme(AccordionExpansionPanel);
